import { ReactElement } from 'react';
import ImageDisplayField from '../fields/ImageDisplayField';
import { ControlRecord } from '../ts/Definitions'
import { OwnerType } from '../ts/enums';

interface Props {
    profile: ControlRecord;
    children?: (false | undefined | ReactElement)[] | ReactElement;
    size?: 'Default' | 'Large' | 'Small';
    concise?: boolean;
    loggedOnUser?: boolean;
    updatedProfile?: (profile: Record<string, any>) => void;
    disableImageClickThrough?: boolean;
}

export default ({ profile, children, size, concise, loggedOnUser, updatedProfile, disableImageClickThrough }: Props) => {
    const ownerType = profile.getOwnerType();
    return (
        <div style={{ display: 'flex', width: '100%' }}>
            <ImageDisplayField
                item={profile}
                size={size}
                disableImageClickThrough={disableImageClickThrough}
                allowFix={loggedOnUser}
                updated={(img) => {
                    profile.profileImage = img;
                    if (updatedProfile) updatedProfile({ profileImage: img });
                }}
            />
            <div className={concise ? 'conciseProfileItemText' : 'profileItemText'} >
                <div className='userNameLabel'>{profile.username}</div>
                {!concise && ownerType === OwnerType.loaned && <div>
                    <div className='userNameLabel'>Loaned To: {profile.getOwner().username}</div>
                    <div className='userNameLabel'>Owned By: {profile.owner}</div>
                </div>}
                {!concise && ownerType === OwnerType.owned && <div className='userNameLabel'>Owned By: {profile.getOwner().username}</div>}
                {children}
            </div>
        </div>)
}